import { LoadingSkeleton } from "@faire/web/slate-deprecated/LoadingSkeleton";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { ResponsiveValues } from "@faire/web/slate/Theme/ResponsiveValues";

export const useGetItemsPerRowResponsive = (
  isSideBarVisible?: boolean
): ResponsiveValues<number> => {
  return isSideBarVisible
    ? ITEMS_PER_ROW_RESPONSIVE_SIDEBAR
    : ITEMS_PER_ROW_RESPONSIVE;
};

export const ITEMS_PER_ROW_RESPONSIVE: ResponsiveValues<number> = {
  mobileAndAbove: 2,
  tabletAndAbove: 4,
  desktopAndAbove: 5,
  xLargeAndAbove: 6,
  xxLargeDesktop: 6,
};

const ITEMS_PER_ROW_RESPONSIVE_SIDEBAR: ResponsiveValues<number> = {
  mobileAndAbove: 2,
  tabletAndAbove: 4,
  desktopAndAbove: 4,
  xLargeAndAbove: 5,
  xxLargeDesktop: 5,
};

const NUM_OF_FILTER_PILLS = 2;

const NUM_OF_PRODUCTS = 60;

export const FilterPillsLoadingList = () => {
  return (
    <div className="flex flex-row items-center justify-start gap-2 overflow-hidden px-4 py-4 lg:px-12">
      {Array.from({ length: NUM_OF_FILTER_PILLS }).map((_, index) => (
        <FilterPill key={index} />
      ))}
    </div>
  );
};

export const SearchPageFooterPlaceholder = () => {
  return <div className="h-[900px] w-full"></div>;
};

const FilterPill = () => {
  return <LoadingSkeleton width="100px" height="40px" borderRadius="20px" />;
};

export const BrandTilesLoadingSkeletonGrid = () => {
  return (
    <div className="flex w-full px-4 lg:px-12">
      <div className="grid w-full grid-cols-2 gap-x-4 gap-y-12 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6">
        {Array.from({ length: NUM_OF_PRODUCTS }).map((_, index) => (
          <BrandTileLoadingSkeleton key={index} />
        ))}
      </div>
    </div>
  );
};

const BrandTileLoadingSkeleton: React.FC<{
  className?: string;
}> = ({ className }) => {
  return (
    <Column className={className} data-test-id="brand-tile-placeholder">
      <LoadingSkeleton width="100%" height="" aspectRatio="1" />
      <Column className="flex-1 py-4">
        <Spacer height={4} />
        <LoadingSkeleton width="100%" height="16px" />
        <Spacer height={4} />
        <LoadingSkeleton width="75%" height="16px" />
        <Spacer height="3x" />
      </Column>
    </Column>
  );
};
